import addCircleBlue from '../../assets/images/icons/add_circle_blue_24dp.svg';
import Card from '../organisms/Card';

import './CreateNewSkillCard.scss';
import clsx from 'clsx';

interface CreateNewSkillCardProps {
  className?: string;
}

export default function CreateNewSkillCard({ className }: CreateNewSkillCardProps) {
  return (
    <Card className={clsx('create-new-skill-card', className)}>
      <img className="icon" src={addCircleBlue} alt="" />
      <div className="label">Create new skill</div>
    </Card>
  );
}
